import * as React from "react";
import { Card, CardContent, CardDescription, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
const menuHighlights = [{
  id: "family-law",
  title: "Family Law",
  description: "Navigating complex domestic matters with discretion, empathy, and unwavering legal precision.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687512/img/family_law_consultation.png",
  badge: "Private Client"
}, {
  id: "real-estate",
  title: "Real Estate",
  description: "Strategic counsel for high-value property acquisitions, developments, and commercial leasing.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687512/img/commercial_real_estate.png",
  price: "Elite",
  priceSuffix: "Advisory"
}, {
  id: "corporate-litigation",
  title: "Corporate Litigation",
  description: "Aggressive representation and risk mitigation for complex commercial disputes and arbitration.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687512/img/corporate_litigation_court.png",
  emphasis: "High-Stakes Defense"
}];
export default function AreasOfMastery() {
  return <section data-section-id="222555" id="areas-of-mastery" className="bg-background py-16 md:py-24 text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-default text-3xl md:text-4xl lg:text-6xl text-foreground mb-4">
            Areas of Mastery
          </h2>
          <p className="text-muted-foreground font-sans max-w-2xl mx-auto text-lg">
            Sterling Law Associates provides elite legal counsel across specialized disciplines, defined by architectural precision and traditional authority.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {menuHighlights.map((item, i) => <Card key={item.id} data-index={i} className="group bg-transparent border border-secondary/40 rounded-md shadow-md flex flex-col overflow-hidden transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] hover:border-primary hover:shadow-[0_10px_30px_-15px_rgba(153,19,51,0.3)]">
              <div className="overflow-hidden">
                <AspectRatio ratio={1}>
                  <img src={item.image} alt={item.title} className="object-cover w-full h-full transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.08]" />
                </AspectRatio>
              </div>
              
              <CardContent className="p-6 md:p-8 flex flex-col grow">
                <div className="h-[2px] w-12 bg-primary mb-6 transition-all duration-500 group-hover:w-20" aria-hidden="true" />
                
                <CardTitle className="font-default text-2xl text-foreground mb-4">
                  {item.title}
                </CardTitle>

                <div className="mb-4 min-h-[2rem] flex items-center">
                  {item.badge && <Badge variant="outline" className="border-secondary text-secondary-foreground font-mono uppercase tracking-widest rounded-md px-3 py-1 text-xs">
                      {item.badge}
                    </Badge>}
                  
                  {item.price && <div className="flex items-baseline gap-2">
                      <span className="font-default text-3xl text-primary">{item.price}</span>
                      <span className="text-muted-foreground text-sm font-sans uppercase tracking-wider">{item.priceSuffix}</span>
                    </div>}
                  
                  {item.emphasis && <span className="font-default italic text-lg text-primary">
                      {item.emphasis}
                    </span>}
                </div>

                <CardDescription className="text-muted-foreground font-sans text-base leading-relaxed mt-auto">
                  {item.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}